export const Kind = 'EXPORT_NOTE_CHECKED_IN';

export enum Status {
  Created = 'CREATED',
  Fetching = 'FETCHING',
  AwaitingExport = 'AWAITING_EXPORT',
  ExportingManually = 'EXPORTING_MANUALLY',
  ContentNeedsReview = 'CONTENT_NEEDS_REVIEW',
  Exporting = 'EXPORTING',
  ExportNeedsReview = 'EXPORT_NEEDS_REVIEW',
  ExportedSuccessfully = 'EXPORTED_SUCCESSFULLY',
  ExportedManually = 'EXPORTED_MANUALLY',
  ExportCanceled = 'EXPORT_CANCELED',
}
